import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    --primary-color: #2E7EF0;
    --primary-dark: #1E60B5;
    --primary-light: #5698F7;
    --secondary-color: #FF7846;
    --background-color: #F9FAFB;
    --white: #FFFFFF;
    --black: #121212;
    --gray-100: #F3F4F6;
    --gray-200: #E5E7EB;
    --gray-300: #D1D5DB;
    --gray-400: #9CA3AF;
    --gray-500: #6B7280;
    --gray-600: #4B5563;
    --gray-700: #374151;
    --gray-800: #1F2937;
    --gray-900: #111827;
    --success: #10B981;
    --warning: #F59E0B;
    --error: #EF4444;
    --info: #3B82F6;
  }

  html {
    height: 100%;
    /* overflow: hidden; Removed to fix mobile scroll behavior */
    overflow-x: hidden;
  }

  body {
    font-family: 'Cairo', sans-serif;
    font-display: swap; /* Add this: Ensures text is visible immediately with fallback font */
    background-color: var(--background-color);
    color: var(--gray-800);
    font-size: 16px;
    line-height: 1.5;
    direction: rtl;
    text-align: right;
    
    width: 100%;
    height: 100%;
    /* overflow-y: auto; Removed */
    overflow-x: hidden;

    box-sizing: border-box;
    position: relative;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch; /* For smooth scrolling on iOS */
  }

  #root {
    min-height: 100%;
    display: flex;
    flex-direction: column;
  }

  /* Prevent horizontal scroll on mobile */
  @media (max-width: 768px) {
    html, body {
      overflow-x: hidden;
      width: 100%;
      max-width: 100%;
      position: relative;
    }

    * {
      box-sizing: border-box;
    }

    #root {
      width: 100%;
      max-width: 100%;
      overflow-x: hidden;
    }
  }

  /* Ensure all elements respect box model */
  *, *::before, *::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  button, input, textarea, select {
    font-family: 'Cairo', sans-serif;
  }

  button {
    cursor: pointer;
    border: none;
    outline: none;
  }

  ul, ol {
    list-style: none;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  /* Container widths */
  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1rem;
  }

  /* Typography */
  h1, h2, h3, h4, h5, h6 {
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 1rem;
  }

  h1 {
    font-size: 2.5rem;
  }

  h2 {
    font-size: 2rem;
  }

  h3 {
    font-size: 1.75rem;
  }

  h4 {
    font-size: 1.5rem;
  }

  h5 {
    font-size: 1.25rem;
  }

  h6 {
    font-size: 1rem;
  }

  p {
    margin-bottom: 1rem;
  }

  /* Buttons */
  .btn {
    display: inline-block;
    padding: 0.75rem 1.5rem;
    border-radius: 0.5rem;
    font-weight: 600;
    transition: all 0.3s ease;
  }

  .btn-primary {
    background-color: var(--primary-color);
    color: var(--white);
  }

  .btn-primary:hover {
    background-color: var(--primary-dark);
  }

  .btn-secondary {
    background-color: var(--secondary-color);
    color: var(--white);
  }

  .btn-secondary:hover {
    background-color: #E56A3C;
  }

  .btn-outline {
    background-color: transparent;
    border: 2px solid var(--primary-color);
    color: var(--primary-color);
  }

  .btn-outline:hover {
    background-color: var(--primary-color);
    color: var(--white);
  }

  /* Utilities */
  .text-center {
    text-align: center;
  }

  .mt-1 { margin-top: 0.25rem; }
  .mt-2 { margin-top: 0.5rem; }
  .mt-3 { margin-top: 0.75rem; }
  .mt-4 { margin-top: 1rem; }
  .mt-5 { margin-top: 1.25rem; }
  .mt-6 { margin-top: 1.5rem; }
  .mt-8 { margin-top: 2rem; }
  .mt-10 { margin-top: 2.5rem; }
  .mt-12 { margin-top: 3rem; }

  .mb-1 { margin-bottom: 0.25rem; }
  .mb-2 { margin-bottom: 0.5rem; }
  .mb-3 { margin-bottom: 0.75rem; }
  .mb-4 { margin-bottom: 1rem; }
  .mb-5 { margin-bottom: 1.25rem; }
  .mb-6 { margin-bottom: 1.5rem; }
  .mb-8 { margin-bottom: 2rem; }
  .mb-10 { margin-bottom: 2.5rem; }
  .mb-12 { margin-bottom: 3rem; }

  .mx-auto { margin-left: auto; margin-right: auto; }

  /* Form styles */
  .form-group {
    margin-bottom: 1.5rem;
  }

  .form-label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 600;
  }

  .form-control {
    width: 100%;
    padding: 0.75rem 1rem;
    border: 1px solid var(--gray-300);
    border-radius: 0.5rem;
    font-size: 1rem;
  }

  .form-control:focus {
    outline: none;
    border-color: var(--primary-color);
    box-shadow: 0 0 0 3px rgba(46, 126, 240, 0.1);
  }

  /* Card styles */
  .card {
    background-color: var(--white);
    border-radius: 0.75rem;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
    padding: 1.5rem;
  }

  /* Accessibility enhancements */
  /* تحسين التركيز */
  .keyboard-navigation *:focus {
    outline: 3px solid var(--primary-color) !important;
    outline-offset: 2px !important;
  }

  /* تحسين التباين العالي */
  .high-contrast {
    filter: contrast(150%);
  }

  .high-contrast * {
    border-color: #000 !important;
  }

  /* أحجام النص */
  .text-small { font-size: 14px; }
  .text-normal { font-size: 16px; }
  .text-large { font-size: 18px; }
  .text-extra-large { font-size: 20px; }

  /* تقليل الحركة */
  .reduce-motion * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }

  /* تحسين الروابط */
  a:focus, button:focus {
    text-decoration: underline;
  }

  /* تحسين النماذج */
  input:focus, textarea:focus, select:focus {
    box-shadow: 0 0 0 3px rgba(46, 126, 240, 0.3) !important;
  }

  /* إخفاء المحتوى للقارئات الشاشة فقط */
  .sr-only {
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    padding: 0 !important;
    margin: -1px !important;
    overflow: hidden !important;
    clip: rect(0, 0, 0, 0) !important;
    white-space: nowrap !important;
    border: 0 !important;
  }

  /* تحسين الأداء */
  .will-change-transform {
    will-change: transform;
  }

  .will-change-opacity {
    will-change: opacity;
  }

  /* تحسين التحميل */
  .loading-skeleton {
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: loading 1.5s infinite;
  }

  @keyframes loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;

export default GlobalStyles;